import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PacingUploadResults } from 'types'

export interface PacingManagerState {
  file?: File
  fileName: string
  uploadResults?: PacingUploadResults
  isLoading: boolean
  error?: string
}

const initialState: PacingManagerState = {
  file: null,
  fileName: '',
  uploadResults: null,
  isLoading: false,
  error: null,
}

const slice = createSlice({
  name: 'pacingManager',
  initialState,
  reducers: {
    pacingFileSelected(state, action: PayloadAction<File>) {
      state.file = action.payload
      state.fileName = action.payload?.name || ''
    },
    pacingFileSubmitting(state) {
      state.isLoading = true
      state.error = null
      state.uploadResults = null
    },
    pacingFileSucceeded(state, action: PayloadAction<PacingUploadResults>) {
      state.file = null
      state.fileName = ''
      state.uploadResults = action.payload
      state.isLoading = false
      state.error = null
    },
    pacingFileError(state, action: PayloadAction<string>) {
      state.file = null
      state.fileName = ''
      state.uploadResults = null
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export const actions = slice.actions
export default slice.reducer
